import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axiosInstance from "../../api/axiosInstance";
import ReportModal from "../../components/ReportModal";
import CreateReportModal from "../../components/CreateReportModal";
import { useAppSelector } from "../../store/hooks";
import TodaysPatientAppointments from "../../components/TodaysPatientAppointments";

export default function PatientReports() {
  const params = useParams();
  const auth = useAppSelector((s) => s.auth.user);

  const phone = auth?.roles?.includes("doctor")
    ? params?.phone
    : auth?.phone;

  const isDoctor = auth?.roles.includes("doctor");

  const [reports, setReports] = useState([]);
  const [selected, setSelected] = useState(null);
  const [createOpen, setCreateOpen] = useState(false);

  useEffect(() => {
    if (phone) {
      axiosInstance.get(`/reports/patient/${phone}`).then((res) => setReports(res.data));
    }
  }, [phone]);

  return (
    <>
      {isDoctor && (
        <TodaysPatientAppointments patientPhone={phone} />
      )}

      <div className="p-6 min-h-screen bg-gray-50">
        <h1 className="text-3xl font-bold mb-4">Reports for {phone}</h1>
        {isDoctor && (
          <button
            onClick={() => setCreateOpen(true)}
            className="mb-4 px-4 py-2 bg-green-600 text-white rounded-lg"
          >
            Create New Report
          </button>
        )}

        <div className="space-y-4">
          {reports.length === 0 && (
            <p className="text-gray-500">No reports found.</p>
          )}
          {reports.map((r) => {
            const date = new Date(r.createdAt);
            const formattedDate = date.toLocaleDateString();
            const formattedTime = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

            return (
              <div
                key={r.id}
                className="flex items-center justify-between p-4 bg-white shadow rounded-lg"
              >
                <div className="flex items-center gap-4">
                  <img
                    src={r.doctor?.profile}
                    alt="doctor"
                    className="w-14 h-14 rounded-full object-cover border"
                  />

                  <div>
                    <p className="font-semibold text-lg">{r.doctor?.name}</p>
                    <p className="text-sm text-gray-500">
                      {formattedDate} • {formattedTime}
                    </p>
                    <p className="text-gray-700 mt-1 line-clamp-1">{r.comment}</p>
                  </div>
                </div>

                <button
                  onClick={() => {
                    console.log(r);
                    setSelected(r)
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg"
                >
                  View
                </button>
              </div>
            );
          })}
        </div>


        {selected && (
          <ReportModal
            report={selected}
            onClose={() => setSelected(null)}
            readOnly={(() => {
              if (!isDoctor) return true; // patients never edit

              const created = new Date(selected.createdAt);
              const now = new Date();

              // Compare only the date (not time)
              const sameDay =
                created.getFullYear() === now.getFullYear() &&
                created.getMonth() === now.getMonth() &&
                created.getDate() === now.getDate();

              return !sameDay; // if not the same day → readOnly = true
            })()}
          />
        )}


        {createOpen && (
          <CreateReportModal
            patientPhone={phone}
            onClose={() => setCreateOpen(false)}
          />
        )}
      </div>
    </>
  );
}
